/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Filter_PromoInputs */



/**
* | output |
* | --- |
* | "Filter by promo" |
*
* @param {Promo_Ledger_Filter_PromoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_filter_promo = /** @type {((inputs?: Promo_Ledger_Filter_PromoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Filter_PromoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer par promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar por promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Filtrar por promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra per promo")
	return /** @type {LocalizedString} */ ("Filter by promo")
});